'use strict';

define('accordion',['jquery'], function ($) {

  var
    MENU_LIST_SUB_CSS_SEL = '.menu__list-sub',
    IS_OPEN = 'is-open';

  var
    $menu = $('.menu__list-container').find('> ul'),
    $isAccordionItem = $menu.find('.is-accordion'),
    is_animating = false,
    opts = {
      animation_speed: 300
    };

  var initialize = function() {
    attachEvents();
  };

  var attachEvents = function() {
    $isAccordionItem.find('> a').click(toggleSubMenu);
  };

  var toggleSubMenu = function(){

    var
      $target,
      $targetItem,
      $subMenu;

    if(is_animating) {
      return false;
    }

    is_animating = true;
    $target      = $(this);
    $targetItem  = $target.closest('li');
    $subMenu     = $target.next(MENU_LIST_SUB_CSS_SEL);

    $targetItem.toggleClass(IS_OPEN);

    if(AS3.track_submenu && $targetItem[0].classList.contains(IS_OPEN))
    {
      AS3.trackUrl("Submenu open: " + $targetItem[0].innerText)
    }
    $subMenu.slideToggle(opts.animation_speed, function() {
      is_animating = false;
    });

    return false;
  };

  return {
    init: initialize
  };

});

